import React from 'react';
import './Explore.css';

import '../Home/Home.css';
import Helmet from '../../component/Helmet/Helmet';
import PostCard from "../../component/layouts/PostCard";


import '../../component/post/post.css';


// Json Posts
import '../../component/post/post';
import Sidebar from '../../component/layouts/Sidebar';
import MobileTopBar from '../../component/layouts/MobileTopBar';
import RightSide from '../../component/layouts/rightSide';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';


// Powered by dotyet.com

const Explore = () => {


  const {token, setToken, user} = useContext(AppContext);

      
    const [formData, setFormData] = useState({
                comment:'',
                post_id:'',
        });
            
    const [errors, setErrors] = useState({}); 


    const [posts, setPosts] = useState({}); 

    const [likedPosts, setLikedPosts] = useState({});

    const toggleLike = async (postId) => {
    setLikedPosts((prev) => ({
      ...prev,
      [postId]: !prev[postId]
    }));

      const response = await fetch('https://dashboard.tiktaka.com/api/likeAndUnlike', {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,  
          'Content-Type': 'application/json',
          'Accept': 'application/json'

        },
        body: JSON.stringify({post_id: postId})
      });

      const data = await response.json();


       if (response.ok) {
            alert("✅ تم بنجاح!");

          getPosts(); 

          console.log(7777);
          console.log(user.id);
          // console.log(data);


        } else if (response.status === 422) {
            setErrors(data.errors);
        } else {
            console.log(data.message);
        }
    
  };


  async function getPosts() {

    const res = await fetch('https://dashboard.tiktaka.com/api/explore',{
          headers: {
            Authorization: `Bearer ${token}`,  
          },
    });

    const data = await res.json();

    // console.log('====================================');
    // console.log(data);
    // console.log('====================================');

    if(res.ok){
        setPosts(data.posts);
        // console.log(1111);
        // console.log(data.posts.length);
        
    }

  }
  useEffect(()=>{
    getPosts();
  }, []);



  return (
  <Helmet title='Explore'>
    <div className="Explore">
  
    <Sidebar/>

    <div className='midSide'>
    <div className='middleSideHome'>
    
        <MobileTopBar/>
      
      {/* Start Main Section */}

        <div className='postSection'>

            {posts.length > 0 ? (
              posts.map((post) => (
                <PostCard
                  key={post.id}
                  post={post}
                  user={user}
                  token={token}
                  toggleLike={toggleLike}
                  getPosts={getPosts}
                />
              ))
            ) : (
              <p>There is no posts</p>
            )}
          
          
        </div>
    </div>
    </div>
    
    <RightSide/>
  </div>
  </Helmet>
  );
};

export default Explore;